(function auditDefinition() {
    'use strict';
    angular.module('Entities')
        .service('migratorService', [
            'restUrlBuilder', function migratorService(restUrlBuilder) {

                this.get = function get(id, description, batch, page, itemsPerPage) {
                    var params = { Id: id, Description: description, Batch: batch, Page: page, ItemPerPage: itemsPerPage };

                    return restUrlBuilder.all('migrator')
                        .get({ params: params });
                };

                this.getById = function getById(id) {
                    return restUrlBuilder.one('migrator', id).get();
                };

                this.getBatch = function getBatch(migratorId, batch) {

                    return restUrlBuilder.one('migrator', migratorId).one('batch', batch).get();
                };

            }
        ]);
})();